const disabledAllMenuItems = () => Array.prototype.forEach.call(document.querySelectorAll('.menu-items li'), el => {
  el.classList.remove('active')
})

const animatedScrollTop = (value, done = () => {}) => $('html, body').animate({
  scrollTop: value
}, 750, done)

const extractHash = href => {
  if (!href) return ''

  return new URL(href, window.location.href).hash
}

const extractSearch = href => {
  if (!href) return ''

  return new URL(href, window.location.href).search
}

const updateUrl = (hash, search = window.location.search) => {
  const url = new URL(window.location.href)
  url.search = search
  url.hash = hash

  window.history.pushState(null, document.title, `${url.pathname}${url.search}${url.hash}`)
}


const changeHash = (hash, search) => {
  updateUrl(hash, search)

  dataLayer.push({
    'event': 'anchor-changed',
    'mailjet-website': 'MJML'
   })
}

const handleWindowScroll = ({ leftMenu, questions, firstQuestion, lastQuestion, lastQuestionPosition }) => {
  Array.prototype.forEach.call(questions, el => {
    const { scrollY } = window
    const clientRect = el.getBoundingClientRect()
    const hash = el.getAttribute('id')

    const firstQuestionClientRect = firstQuestion.getBoundingClientRect()
    const lastQuestionClientRect = lastQuestion.getBoundingClientRect()

    if (firstQuestionClientRect.top <= 0 &&
        lastQuestionClientRect.top > 225) {
      leftMenu.style.position = 'fixed'
      leftMenu.style.top = 0
    } else if (lastQuestionClientRect.top <= 225) {
      leftMenu.style.position = 'absolute'
      leftMenu.style.top = `${lastQuestionPosition}px`
    } else {
      leftMenu.style.position = ''
      leftMenu.style.top = ''
    }

    if (hash &&
        clientRect.top < 0 &&
        (-(clientRect.top) - clientRect.height) < 0) {
      disabledAllMenuItems()

      const activeMenuLink = document.querySelector(`.menu-items a[href$="#${hash}"]`)
      if (activeMenuLink) {
        activeMenuLink.parentElement.classList.add('active')
      }

      updateUrl(hash)
    }
  })
}

$(() => {
  if (document.getElementById('faq') === null) return

  Array.prototype.forEach.call(document.querySelectorAll('.menu-items a'), el => {
    const href = el.getAttribute('href')
    const hash = extractHash(href)
    const search = extractSearch(href)

    el.addEventListener('click', e => {
      e.preventDefault()

      if (!hash) return

      const target = document.querySelector(hash)
      if (!target) return

      const clientRect = target.getBoundingClientRect()
      const scrollTop = clientRect.top + window.scrollY + 5

      animatedScrollTop(scrollTop, () => changeHash(hash, search))
    })
  })

  Array.prototype.forEach.call(document.querySelectorAll('.back-to-top a, .back-to-top-bottom'), el => {
    const search = extractSearch(el.getAttribute('href'))

    el.addEventListener('click', e => {
      e.preventDefault()

      const clientRect = document.querySelector('.navbar').getBoundingClientRect()
      const scrollTop = clientRect.top + window.scrollY

      animatedScrollTop(scrollTop, () => changeHash('', search))
    })
  })

  const leftMenu = document.querySelector('.container-left-menu > .row')
  const questions = document.querySelectorAll('.row-question')

  const firstQuestion = questions[0]
  const lastQuestion = questions[questions.length - 1]

  const lastQuestionPosition = lastQuestion.getBoundingClientRect().top + window.scrollY - 10

  window.addEventListener('scroll', () => handleWindowScroll({
    leftMenu,
    questions,
    firstQuestion,
    lastQuestion,
    lastQuestionPosition
  }))

  handleWindowScroll({
    leftMenu,
    questions,
    firstQuestion,
    lastQuestion,
    lastQuestionPosition
  })
})
